import Container = Phaser.GameObjects.Container;
import { Scene } from 'phaser';
import { SpineAnim } from './spineAnim';
import Text = Phaser.GameObjects.Text;

export class CoinView extends Container {
    private spine: SpineAnim;
    private text: Text;
    public isCollidable: boolean;

    constructor(
        scene: Scene,
        public op: { function: string; value: number },
    ) {
        super(scene);


        this.scene.events.on('update', this.handleUpdate, this);
        // const graph = this.scene.add.graphics();
        // this.add(graph);
        // graph.fillStyle(0x00ff00, 1);
        // graph.fillCircle(0, 0, 25);

        switch (op.function) {
            case 'add':
                this.initSpine('chips', 0.75);
                this.initText('+', op.value);
                this.spine.loopAnimation(this.spine.spine.getAnimationList()[0]);
                this.spine.y += 50;
                // chips
                break;
            case 'multiply':
                this.initSpine('Suits', 1, Math.random() > 0.5 ? 'Diamonds_C0' : 'Hearts_D0');
                this.initText('x', op.value);
                this.spine.loopAnimation(this.spine.spine.getAnimationList()[0]);
                this.spine.y += 66;
                // diamond hearts
                break;
            case 'divide':
                this.initSpine('eagle_spine', 0.5);
                this.spine.loopAnimation(this.spine.spine.getAnimationList()[1]);
                this.spine.spine.timeScale = 2.8;
                this.spine.y += 15;
                // spades / just eagle

                break;
        }
    }

    public playHit() {
        this.scene.events.emit('hitWithCoin', this.op);
        if (this.op.function === 'divide') {
            const { spine } = this.spine;
            spine.off('complete');
            spine.timeScale = 1.4;
            spine.play('Bite');
            return;
        }

        this.scene.tweens.add({
            targets: this.spine,
            alpha: 0,
            duration: 255,
        });

        this.scene.tweens.add({
            targets: this.text,
            alpha: 0,
            scale: 1.1,
            duration: 265,
            onComplete: () => {
                // this.scene.tweens.killTweensOf(this.spine);
                // this.destroy();
            },
        });

        const spine = new SpineAnim(this.scene, 'vfx_GrabParticles');
        spine.startAnimation(['animation']).then(() => {
            this.destroy();
        });
        this.add(spine);
    }

    private initSpine(name: string, scale: number, specialSlot?: string) {
        this.spine = new SpineAnim(this.scene, name);
        this.add(this.spine);
        this.spine.setScale(scale);
        specialSlot && this.spine.updateSlot(specialSlot);
    }

    private initText(sign: string, value: number) {
        this.text = this.scene.add.text(0, 0, `${sign}${value}`, {
            fontFamily: 'Rubik',
            color: 'white',
            fontSize: 48,
        });
        this.text.setStroke('#000000', 6);
        this.text.setShadow(2, 2, '#000000', 4, true, true);
        this.add(this.text);
        this.text.setOrigin(0.5);
    }

    public destroy(fromScene?: boolean) {
        if (!this.active) return;
        this.scene.events.off('update', this.handleUpdate, this);
        super.destroy(fromScene);
    }

    private handleUpdate() {
        const { tx } = this.getWorldTransformMatrix();
        this.setVisible(tx > -100 && tx < 2020);
    }

    // public playAnimation() {
    //     this.spine.spine.timeScale = 1;
    // }
}
